import React, { useEffect, useState } from 'react';
import { useHttpClient } from '../hooks/useHttpClient';
import { MultiSelect } from 'primereact/multiselect';
import { isEmpty } from 'lodash';
import { Skeleton } from 'primereact/skeleton';
import { isEmptyArray } from 'formik';
import AutoFocusDropdown from './AutoFocusDropdown';
import { useMountEffect, useUpdateEffect } from 'primereact/hooks';

const SeleccionarEmisor = (props) => {
    const httpClient = useHttpClient();
    const [issuers, setIssuers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState({ code: '', name: '' });
    const [values, setValues] = useState([]);
    const [issuersMap, setIssuersMap] = useState(new Map());

    useMountEffect(() => {
        setIsLoading(true);
        httpClient
            .get('admin/emisor/all')
            .then((response) => {
                const tmpIssuers = [];
                const tmpIssuersMap = new Map();
                for (let i = 0; i < response.data.length; i++) {
                    const issuer = response.data[i];
                    if (props.filterByTimbrado && !issuer.administrar_timbrado) {
                        continue;
                    }
                    tmpIssuers.push({
                        code: issuer.ruc,
                        name: issuer.razon_social
                    });
                    tmpIssuersMap.set(response.data[i].ruc, {
                        code: issuer.ruc,
                        name: issuer.razon_social
                    });
                }
                setIssuers(tmpIssuers);
                setIssuersMap(tmpIssuersMap);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
            });
    });

    useUpdateEffect(() => {
        if (!isEmpty(props.excludedList)) {
            setIsLoading(true);
            httpClient
                .get('admin/emisor/all')
                .then((response) => {
                    const tmpIssuers = [];
                    const tmpIssuersMap = new Map();
                    for (let i = 0; i < response.data.length; i++) {
                        const issuer = response.data[i];
                        if (props.filterByTimbrado && !issuer.administrar_timbrado) {
                            continue;
                        }
                        if (!isEmptyArray(props.excludedList)) {
                            let shouldAvoid = false;

                            for (let j = 0; j < props.excludedList.length; j++) {
                                if (props.excludedList[j].code === issuer.ruc) {
                                    shouldAvoid = true;
                                    break;
                                }
                            }

                            if (shouldAvoid) {
                                continue;
                            }
                        }
                        tmpIssuers.push({
                            code: issuer.ruc,
                            name: issuer.razon_social
                        });
                        tmpIssuersMap.set(response.data[i].ruc, {
                            code: issuer.ruc,
                            name: issuer.razon_social
                        });
                    }
                    setIssuers(tmpIssuers);
                    setIssuersMap(tmpIssuersMap);
                    setIsLoading(false);
                })
                .catch((error) => {
                    setIsLoading(false);
                });
        }
    }, [props.excludedList]);

    useEffect(() => {
        if (!isEmpty(props.isMulti)) {
            const tmpAccess = [];
            for (let i = 0; i < props.value.length; i++) {
                if (issuersMap.has(props.value[i].code)) {
                    tmpAccess.push(issuersMap.get(props.value[i].code));
                }
            }
            setValues(tmpAccess);
            return;
        }
        if (issuersMap.has(props.value?.code)) {
            setValue(issuersMap.get(props.value.code));
        }
    }, [issuersMap, props.value, props.isMulti]);

    const getSelect = () => {
        if (isLoading) {
            return <Skeleton id={props.id} disabled={props.isEditing} height={props.skeletonHeigh} width={props.skeletonWidth} className="mb-2"></Skeleton>;
        }
        if (props.isMulti) {
            return (
                <MultiSelect
                    id={props.id}
                    filter
                    value={values}
                    onChange={(e) => props.onChange(e.value)}
                    onBlur={() => props.onBlur(true)}
                    options={issuers}
                    optionLabel="name"
                    display="chip"
                    disabled={props.disabled}
                    placeholder={props.placeHolder}
                    style={props.style}
                    className={props.className}
                />
            );
        }
        return (
            <AutoFocusDropdown
                id={props.id}
                filter
                disabled={props.disabled}
                value={value}
                checkmark={true}
                onChange={(e) => props.onChange(e.value)}
                onBlur={() => props.onBlur(true)}
                options={issuers}
                optionLabel="name"
                placeholder={props.placeHolder}
                style={props.style}
                className={props.className}
            />
        );
    };

    return getSelect();
};
export default SeleccionarEmisor;
